import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nasdaq-widget',
  templateUrl: './nasdaq-widget.component.html',
  styleUrls: ['./nasdaq-widget.component.scss'],
  standalone: false
})
export class NasdaqWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
